<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />

        <router-link :to="{ path: BACKEND_URL + '/persons/edit/' + person.id, props: { id: person.id } }" v-if="$can('person-edit')">
          <action-button type="edit" />
        </router-link>

        <action-button type="delete" @click="del(person.id)" v-if="$can('person-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.first_name"
                  :label="$t('persons.first_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.middle_name"
                  :label="$t('persons.middle_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.last_name"
                  :label="$t('persons.last_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field v-model="person.mobile" :label="$t('persons.mobile')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field v-model="person.email" :label="$t('persons.email')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.name"
                  :label="$t('organisations.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="person.created_as_user"
                  v-model="person.created_as_user"
                  :label="$t('persons.create_as_user')"
                  readonly
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-textarea name="person.comments" v-model="person.comments" :label="$t('persons.comments')" readonly></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "PersonForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      person: {},
      organisation: {}
    }
  },

  created() {
    axios
      .get(this.API_URL + "person/" + this.id)
      .then((res) => {
        this.person = res.data.data
        this.organisation = res.data.data.organisation

        this.page_title = this.$t("persons.view_person", { name: this.person.first_name + " " + this.person.last_name })
      })
      .catch((err) => console.log(err))
  },

  methods: {
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "person/" + id)
            .then(() => {
              vm.$router.push(vm.BACKEND_URL + "/persons")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
